// extracted by mini-css-extract-plugin
module.exports = {"marginminus":"orders-form_marginminus__1CkI_","isPolarisCheckbox":"orders-form_isPolarisCheckbox__3pabI","label-style-DZ":"orders-form_label-style-DZ__34tJv"};